import React from "react";

import classnames from "classnames";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { t } from "i18next";

interface Props {
    isValidateButtonDisabled: boolean;
    onCancel: () => void;
    onValidate: () => void;
    isConsult: boolean;
}

const FormFooterButtons: React.FC<Props> = ({
    isValidateButtonDisabled,
    onCancel,
    onValidate,
    isConsult,
}) => (
    <div className="pt-1 pb-2 d-flex justify-content-end">
        <CustomSecondaryColorButton
            outline
            rounded
            className="mr-2 sdv_btn_FRcancel cmn_btn_cancel"
            variant="light"
            onClick={onCancel}
        >
            {t("Cancel")}
        </CustomSecondaryColorButton>
        <CustomMainColorButton
            rounded
            variant="primary"
            disabled={isValidateButtonDisabled}
            onClick={onValidate}
            className={classnames("sdv_btn_FRvalidate cmn_btn_validate", {
                "not-allowed-input-vr__clz": isConsult,
            })}
        >
            {t("Validate")}
        </CustomMainColorButton>
    </div>
);

export default FormFooterButtons;
